import { gsap } from 'gsap';

export default class AnimateBubbles {
    static init() {
        const path = document.querySelector('#path');
        const bubbles = document.querySelectorAll('#animation-path circle');

        // Object that gsap can animate
        bubbles.forEach((element, index) => {
            const circleX = element.cx.baseVal.value;
            const circleY = element.cy.baseVal.value;
            const val = { distance: path.getTotalLength() - 300 };
            const distanceX = circleX - path.getPointAtLength(val.distance).x;
            const distanceY = circleY - path.getPointAtLength(val.distance).y;

            const bubble = {
                'element' : element,
                'circleX':  circleX,
                'distanceX': distanceX,
                'circleY':  circleY,
                'distanceY': distanceY,
                'index': index,
            };

            createTween(bubble, val);
        });

        function createTween(bubble, val) {
            // Create a tween
            const tween = gsap.to(val, {
                // Animate from distance 0 to the total distance
                distance: 0,
                // Loop the animation
                repeat: -1,
                // Make the animation lasts 5 seconds
                duration: 60,

                // Function call on each frame of the animation
                onUpdate: () => {

                    // Query a point at the new distance value
                    const point = path.getPointAtLength(val.distance);
                    const distanceFromPath = bubble.distanceX + point.x;

                    bubble.element.setAttribute('cx', distanceFromPath);
                    bubble.element.setAttribute('cy', point.y);

                    bubble.element.setAttribute('style', 'opacity:' + (point.y > 4900 || point.y < 10 ? '0' : '1'))
                }
            });
            tween.progress((bubble.index + 1) * (1/(bubbles.length)));
        }
    }
}
